import { Link } from "react-router-dom";
import { FRANCHISE_TIERS, FRANCHISE_COMPARISON, GROUP_LABEL } from "../lib/franchise";
import { Check, Minus, ArrowRight } from "lucide-react";

export default function FranchiseCompare() {
  const cell = (val) => {
    if (val === true) return <Check size={18} style={{ color: "var(--brass)" }} />;
    if (val === false) return <Minus size={16} style={{ color: "var(--ink-faint)", opacity: 0.5 }} />;
    return <span className="text-sm" style={{ color: "var(--ink)" }}>{val}</span>;
  };

  const groups = ["basic", "full", "unlimited"];

  return (
    <div data-testid="franchise-compare-page" className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-32 pb-24">
      <div className="mb-16 reveal text-center">
        <p className="eyebrow mb-4">Franchise Tiers · Side by Side</p>
        <h1 className="font-display text-6xl md:text-7xl mb-6 leading-[0.95]">Compare every feature.</h1>
        <p className="text-lg max-w-2xl mx-auto" style={{ color: "var(--ink-muted)" }}>
          Starter covers the basics. Grow-Rich adds the full package. Enterprise removes every ceiling.
        </p>
      </div>

      <div className="overflow-x-auto" style={{ border: "1px solid var(--hairline)" }}>
        <table className="w-full min-w-[900px]">
          <thead>
            <tr style={{ borderBottom: "1px solid var(--hairline-strong)" }}>
              <th className="text-left p-6 eyebrow" style={{ width: "40%" }}>Feature</th>
              <th className="text-center p-6">
                <p className="eyebrow mb-2">Starter</p>
                <p className="font-display text-3xl" style={{ color: "var(--brass)" }}>{FRANCHISE_TIERS.starter.setupDisplay}</p>
                <p className="text-xs uppercase tracking-[0.2em]" style={{ color: "var(--ink-faint)" }}>setup</p>
                <p className="text-sm mt-1" style={{ color: "var(--brass)" }}>{FRANCHISE_TIERS.starter.monthlyDisplay}</p>
              </th>
              <th className="text-center p-6" style={{ background: "var(--surface)" }}>
                <p className="eyebrow mb-2" style={{ color: "var(--brass)" }}>★ Grow-Rich</p>
                <p className="font-display text-3xl" style={{ color: "var(--brass)" }}>{FRANCHISE_TIERS.grow_rich.setupDisplay}</p>
                <p className="text-xs uppercase tracking-[0.2em]" style={{ color: "var(--ink-faint)" }}>setup</p>
                <p className="text-sm mt-1" style={{ color: "var(--brass)" }}>{FRANCHISE_TIERS.grow_rich.monthlyDisplay}</p>
              </th>
              <th className="text-center p-6">
                <p className="eyebrow mb-2">Enterprise</p>
                <p className="font-display text-3xl" style={{ color: "var(--brass)" }}>{FRANCHISE_TIERS.enterprise.setupDisplay}</p>
                <p className="text-xs uppercase tracking-[0.2em]" style={{ color: "var(--ink-faint)" }}>setup</p>
                <p className="text-sm mt-1" style={{ color: "var(--brass)" }}>{FRANCHISE_TIERS.enterprise.monthlyDisplay}</p>
              </th>
            </tr>
          </thead>
          <tbody>
            {groups.map((g) => {
              const rows = FRANCHISE_COMPARISON.filter((r) => r.group === g);
              return (
                <>
                  <tr key={`hdr-${g}`} style={{ background: "var(--surface)" }}>
                    <td colSpan={4} className="px-6 py-3 eyebrow" style={{ color: "var(--brass)" }}>
                      {GROUP_LABEL[g]}
                    </td>
                  </tr>
                  {rows.map((row, i) => (
                    <tr key={row.feature} style={{ borderTop: i === 0 ? "1px solid var(--hairline-strong)" : "1px solid var(--hairline)" }}>
                      <td className="p-5 text-sm" style={{ color: "var(--ink)" }}>{row.feature}</td>
                      <td className="p-5 text-center">{cell(row.starter)}</td>
                      <td className="p-5 text-center" style={{ background: "var(--surface)" }}>{cell(row.grow_rich)}</td>
                      <td className="p-5 text-center">{cell(row.enterprise)}</td>
                    </tr>
                  ))}
                </>
              );
            })}
            <tr style={{ borderTop: "1px solid var(--hairline-strong)" }}>
              <td className="p-6"></td>
              <td className="p-6 text-center">
                <Link to="/franchise/checkout?tier=starter" data-testid="compare-cta-starter" className="btn-ghost !py-2 !px-4 inline-flex">
                  Start Starter <ArrowRight size={12} />
                </Link>
              </td>
              <td className="p-6 text-center" style={{ background: "var(--surface)" }}>
                <Link to="/franchise/checkout?tier=grow_rich" data-testid="compare-cta-grow_rich" className="btn-brass !py-2 !px-4 inline-flex">
                  Choose Grow-Rich <ArrowRight size={12} />
                </Link>
              </td>
              <td className="p-6 text-center">
                <Link to="/franchise/checkout?tier=enterprise" data-testid="compare-cta-enterprise" className="btn-ghost !py-2 !px-4 inline-flex">
                  Apply Enterprise <ArrowRight size={12} />
                </Link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <p className="text-center text-xs uppercase tracking-[0.2em] mt-10" style={{ color: "var(--ink-faint)" }}>
        Upgrade at any time · Flexible payment plans on Grow-Rich and Enterprise
      </p>
    </div>
  );
}
